import escapeStringRegexp from 'escape-string-regexp';
import partition from 'lodash/partition';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { shareModalToggleShareSuccess } from 'actions/multiShare';
import { toggleSlackInviteModal } from 'actions/slack';
import { SLACK_INVITE_MODAL_VIEWED, SLACK_INVITE_SENT } from 'constants/events';
import { LOOM_URI } from 'constants/routes';
import { DM } from 'constants/slack';
import { shareModalClickHandler } from 'creators/multiShare';
import { postSlackInviteCreator } from 'creators/slack';
import * as analytics from 'utilities/analytics';

import ENCOURAGE_SHARING_ENVELOPE from 'img/illustrations/encourage-sharing-envelope.svg';
import SLACK_VIEW_TRACKING_EXAMPLE from 'img/illustrations/slack-view-tracking-example.svg';

import { INVITE_TEAM_VIEW_THRESHOLD } from '../../../../shared/constants/invites';
import { SLACK } from '../../../../shared/constants/oAuthKeys';

import Button from 'components/ui-components/button';
import Checkbox from 'components/ui-components/checkbox';

import './styles.less';

const DEFAULT_STATE = {
  inviteCount: 0,
  filterBy: '',
  unlockSuccesful: false,
  inviteSuccessful: false,
};

const SlackInviteModal = class extends Component {
  state = DEFAULT_STATE;

  render() {
    let inviteString;
    let content = null;
    const inviteCount = this.props.multiShare.search_content.length;
    const { slack } = this.props;

    if (this.state.unlockSuccesful) {
      if (inviteCount === 1) {
        inviteString = '1 invite has';
      } else {
        inviteString = `${inviteCount} invites have`;
      }

      content = (
        <div className="slack-share-modal" onClick={e => e.stopPropagation()}>
          <div className="close" onClick={this.onClose} />
          <div className="invite-count">{inviteString} been sent via Slack</div>
          <div className="proclamation">View Lists Unlocked!</div>
          <img className="view-example" src={SLACK_VIEW_TRACKING_EXAMPLE} />
          <div className="details">
            You will now be able to see viewed your videos! Hover over the video
            view count to access the video view list.
          </div>
          <div className="note">
            Note: Videos viewed by people not registered with Loom will still be
            anonymous.
          </div>
          <Button
            buttonType="a1"
            buttonClass="latest-video-button"
            value="Go to Latest Video"
            onClicked={() => (window.location.href = '/most-recent-video')}
          />
        </div>
      );
    } else if (this.state.inviteSuccessful) {
      const inviteeList = this.props.multiShare.search_content;
      const otherInviteeCount = inviteCount - 1;
      const inviteeFirstName =
        inviteeList[0].profile.first_name ||
        inviteeList[0].real_name.split(' ')[0] ||
        inviteeList[0].name;

      if (inviteCount === 1) {
        inviteString = `Invite sent to ${inviteeFirstName}`;
      } else {
        const other = otherInviteeCount === 1 ? 'other' : 'others';

        inviteString = `Invites sent to ${inviteeFirstName} and ${otherInviteeCount} ${other}`;
      }

      content = (
        <div className="slack-share-modal" onClick={e => e.stopPropagation()}>
          <div className="close" onClick={this.onClose} />
          <img className="encourage-sharing" src={ENCOURAGE_SHARING_ENVELOPE} />
          <div className="invite-count">{inviteString}</div>
        </div>
      );
    } else {
      if (inviteCount === 0) {
        inviteString = 'Send Invites';
      } else if (inviteCount === 1) {
        inviteString = 'Send 1 Invite';
      } else {
        inviteString = `Send ${inviteCount} Invites`;
      }

      const filterBy = this.state.filterBy.toLowerCase();
      const nameRegex = new RegExp(`(?:^|\\s)${escapeStringRegexp(filterBy)}`);
      const handleRegex = new RegExp(`^${escapeStringRegexp(filterBy)}`);

      // only show people who are eligible AND match the search string
      const peopleList = this.props.peopleList.filter(person => {
        return (
          nameRegex.test(person.dm.real_name.toLowerCase()) ||
          handleRegex.test(person.dm.name.toLowerCase())
        );
      });

      const isEveryoneSelected = peopleList.every(person => person.active);

      // split list into two arrays: [people NOT on Loom] + [people on Loom]
      const peopleListSplit = partition(
        peopleList,
        person => !slack.users_on_loom.includes(person.dm.id)
      );

      const peopleListSorted = peopleListSplit[0].concat(
        peopleListSplit[1].map(person => {
          return {
            ...person,
            onLoom: true,
          };
        })
      );

      content = (
        <div className="slack-share-modal" onClick={e => e.stopPropagation()}>
          <div className="close" onClick={this.onClose} />
          <h2 className="prompt">🔓 Unlock Who Viewed</h2>
          <p className="instructions">
            Invite {INVITE_TEAM_VIEW_THRESHOLD} teammates to Loom and instantly
            unlock the ability to see who views each video.
          </p>
          <div className="search">
            <input
              className="search-input"
              placeholder="Search to add people..."
              onChange={this.filterPeople}
            />
          </div>
          <ul className="people-list">
            {peopleListSorted.length > 0 &&
              peopleListSorted.map(person => {
                return (
                  <li
                    className={`person ${person.active ? 'selected' : ''}`}
                    key={person.dm.name}
                    onClick={() =>
                      this.props.shareModalClickHandler(person.dm.id)
                    }
                  >
                    <div className="avatar">
                      <img
                        className="avatar-image"
                        src={person.dm.profile.image_72}
                      />
                    </div>
                    <div className="id-info">
                      <div className="govt-name">
                        {person.dm.real_name}
                        {person.onLoom && (
                          <span className="on-loom">Already on Loom</span>
                        )}
                      </div>
                      <div className="slack-handle">@{person.dm.name}</div>
                    </div>
                    <Checkbox
                      isChecked={person.active}
                      onEnable={() =>
                        this.props.shareModalClickHandler(person.dm.id)
                      }
                      onDisable={() =>
                        this.props.shareModalClickHandler(person.dm.id)
                      }
                    />
                  </li>
                );
              })}
            {peopleListSorted.length === 0 && (
              <li className="person no-results">
                No matches for {this.state.filterBy}
              </li>
            )}
          </ul>
          <div className="select-all">
            {isEveryoneSelected && (
              <span
                className="select-all-text"
                onClick={() => this.deselectAll(peopleListSorted)}
              >
                Deselect All Teammates
              </span>
            )}
            {!isEveryoneSelected && (
              <span
                className="select-all-text"
                onClick={() => this.selectAll(peopleListSorted)}
              >
                Select All Teammates
              </span>
            )}
          </div>
          <Button
            buttonType="a1"
            buttonClass="invite-button"
            value={
              inviteCount === 0
                ? `Select ${INVITE_TEAM_VIEW_THRESHOLD} teammates`
                : 'Unlock Now'
            }
            onClicked={this.sendInvites}
            disabled={inviteCount === 0}
          />
        </div>
      );
    }

    return (
      <div className="slack-share-modal-backdrop" onClick={this.onClose}>
        {content}
      </div>
    );
  }

  UNSAFE_componentWillUpdate(newProps) {
    if (
      this.props.slack.show_invite_modal === false &&
      newProps.slack.show_invite_modal === true
    ) {
      const { user, multiShare, slackUser, slack, source } = newProps;
      const domain = user.oauth[SLACK].team_domain;

      const team_size = multiShare.dm_content.length;

      const inviter_position =
        user.company_position || (slackUser && slackUser.profile.title);

      analytics.track(SLACK_INVITE_MODAL_VIEWED, {
        source,
        slack_subdomain: domain,
        total_signups: slack.users_on_loom.length,
        team_size,
        inviter_position,
      });
    }
  }

  componentDidMount() {
    let num = 3;

    const { peopleList, slack } = this.props;

    const selections = [];

    peopleList.forEach(person => {
      if (num > 0 && slack && !slack.users_on_loom.includes(person.dm.id)) {
        num = num - 1;
        selections.push(person.dm.id);
      }
    });

    this.props.shareModalClickHandler(selections);
  }

  sendInvites = () => {
    const { user, multiShare, slackUser, slack } = this.props;

    const { search_content: invitees } = multiShare;
    const domain = user.oauth[SLACK].team_domain;

    const team_name = user.oauth[SLACK].team_name;
    const team_size = multiShare.dm_content.length;
    const inviter_position = user.company_position || slackUser.profile.title;

    analytics.track(SLACK_INVITE_SENT, {
      source: this.props.source,
      number_of_invitees: invitees.length,
      slack_subdomain: domain,
      total_signups: slack.users_on_loom.length,
      team_size,
      team_name,
      inviter_position,
    });

    invitees.forEach(invitee => {
      const inviteUrl = `${LOOM_URI}/${domain}/@${slackUser.name}+@${invitee.name}`;
      const inviteeFirstName =
        (invitee.profile || {}).first_name ||
        invitee.real_name.split(' ')[0] ||
        invitee.name;

      this.props
        .postSlackInviteCreator({
          inviter_id: user.id,
          invitee_slack_id: invitee.id,
          channel_type: invitee.type,
          inviter_avatar: slackUser.profile.image_192,
          invitee_avatar: invitee.profile.image_192,
          inviter_email: slackUser.profile.email,
          invitee_email: invitee.profile.email,
          inviter_handle: slackUser.name,
          invitee_handle: invitee.name,
          inviter_first_name: slackUser.profile.first_name,
          invitee_first_name: inviteeFirstName,
          inviter_last_name: slackUser.profile.last_name,
          invitee_last_name: invitee.profile.last_name,
          inviter_position,
          invitee_position: invitee.profile.title,
          invite_url: inviteUrl,
          is_slack_owner: slackUser.is_owner,
          is_slack_admin: slackUser.is_admin,
          slack_subdomain: domain,
          team_name,
          team_size,
          message: {
            text: `Hey ${inviteeFirstName}! I think you use Chrome, right? I'm using an extension called Loom to record instantly shareable videos to help get my message across. I think you'd like it: ${inviteUrl}`,
          },
        })
        .then(response => {
          // responses may come in out of order. once the feature is unlocked,
          // there is no need to keep testing this
          if (this.state.unlockSuccesful) {
            return;
          }

          if (response.inviteCount >= INVITE_TEAM_VIEW_THRESHOLD) {
            this.setState({
              unlockSuccesful: true,
            });

            // the unlock success message stays open indefinitely
            if (this.autoClose) {
              window.clearTimeout(this.autoClose);
            }
          } else {
            this.setState({
              inviteSuccessful: true,
            });

            // the successful send message is ephemeral
            this.autoClose = window.setTimeout(this.onClose, 2000);
          }
        });
    });
  };

  onClose = () => {
    this.props.toggleSlackInviteModal(false);
    this.props.shareModalToggleShareSuccess(false);
    this.setState(DEFAULT_STATE);

    this.props.onClose();
  };

  filterPeople = e => {
    this.setState({
      filterBy: e.target.value,
    });
  };

  selectAll = peopleList => {
    const idList = peopleList
      .map(person => (person.active ? undefined : person.dm.id))
      .filter(id => id !== undefined);

    this.props.shareModalClickHandler(idList);
  };

  deselectAll = peopleList => {
    const idList = peopleList
      .map(person => (person.active ? person.dm.id : undefined))
      .filter(id => id !== undefined);

    this.props.shareModalClickHandler(idList);
  };
};

SlackInviteModal.propTypes = {
  onClose: PropTypes.func,
};

SlackInviteModal.defaultProps = {
  onClose: () => {},
};

const mapStateToProps = state => {
  const { slack, user, multi_share: multiShare } = state;

  let splitOutOwner;
  let peopleList = [];
  let slackUser = {};

  if (user.current.oauth && multiShare.dm_content.length > 0) {
    const slackId = user.current.oauth[SLACK].id;

    splitOutOwner = partition(
      multiShare.dm_content,
      person => person.dm.id === slackId
    );

    peopleList = splitOutOwner[1];
    slackUser = (splitOutOwner[0][0] || {}).dm;
  }

  return {
    slack,
    multiShare,
    peopleList,
    slackUser,
    user: user.current,
    source: slack.invite_modal_source,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    postSlackInviteCreator: argObj => dispatch(postSlackInviteCreator(argObj)),
    shareModalClickHandler: id => dispatch(shareModalClickHandler(DM, id)),
    shareModalToggleShareSuccess: success =>
      dispatch(shareModalToggleShareSuccess(success)),
    toggleSlackInviteModal: show => dispatch(toggleSlackInviteModal(show)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SlackInviteModal);
